import haversine from 'haversine-distance';

interface LatLng {
	lat: number;
	lng: number;
}

/**
 * Uses `haversine-distance` to compute the distance in miles between two lat/lng points
 */
export function milesBetween(a: LatLng, b: LatLng) {
	if (!a || !b) return -1;

	const metersPerMile = 1609.344;

	return haversine(a, b) / metersPerMile;
}
